<template>
  <div
    v-if="isLoadData && smsBal == 0 && isShowWarningSms == 2"
    class="sms-warning"
  >
    <div class="sms-warning-text">
      <i class="material-icons-round me-2">sms_failed</i>
      <span>
        You have {{ smsBal }} SMS Credit. To ensure smooth communication with your
        member, purchase more
        <a id="nav_item_2" href="/sms-and-wa-setup">here!</a>
      </span>
    </div>
    <button type="button" class="sms-warning-close" @click="closeWarningSms()">
      <i class="material-icons-round">close</i>
    </button>
  </div>
  <div
    v-if="isLoadData && dataDashBoard && dataDashBoard.show_anext_banner"
    class="px-3 mt-3"
  >
    <div class="anext-banner" @click="openAnextBanner()">
      <img src="/MEGAPOS Banner.png" alt="ANEXT CreditNow" />
    </div>
  </div>
  <div class="d-flex justify-content-between align-items-center px-3" :class="{ 'mt-3': smsBal == 0 && isShowWarningSms == 2 }">
    <div class="title-page">{{ merchant_name }}</div>
    <!-- <div class="search-box w-50 col-6">
      <div class="input-group d-flex align-items-center position-relative">
        <input
          type="text"
          class="form-control search-input"
          placeholder="Search for a member"
          style="
            border-radius: 5px;
            padding: 10px;
            padding-right: 40px;
            border: 1px solid #ddd;
            width: 100%;
            font-size: 14px;
            direction: ltr !important;
            text-align: left !important;
            background-color: #fff;
          "
        />
        <i
          class="fas fa-search position-absolute"
          style="
            right: 15px;
            top: 50%;
            transform: translateY(-50%);
            color: #666;
          "
        ></i>
      </div>
    </div>
    <div class="language-selector d-flex align-items-center justify-content-end col-md-3 col-6">
      <div class="dropdown">
        <button
          class="dropdown-toggle p-0 mb-0"
          type="button"
          id="languageDropdown"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          style="
            border: none;
            background: none;
            color: inherit;
            text-decoration: none;
          "
        >
          English
        </button>
        <ul
          class="dropdown-menu"
          aria-labelledby="languageDropdown"
          style="min-width: 120px"
        >
          <li>
            <a class="dropdown-item" href="#" @click="changeLanguage('en')"
              >English</a
            >
          </li>
          <li>
            <a class="dropdown-item" href="#" @click="changeLanguage('cn')"
              >Chinese</a
            >
          </li>
        </ul>
      </div>
    </div> -->
  </div>
  <div class="page-header align-items-start mt-3 me-3 flex-column">
    <div class="container mb-4 dash-card" v-if="isLoadData">
      <div class="dash-header">
        <div class="dash-title title-page mb-0">
          <i class="material-icons-round dash-title-icon">insights</i>
          <span>Sales Performance</span>
        </div>
        <div class="dash-filters">
          <div class="dash-filter">
            <span class="dash-filter-label">Branch</span>
            <Multiselect
              v-model="physicalBranchSelected"
              :options="physicalBranches"
              :canClear="false"
            />
          </div>
          <div class="dash-filter">
            <span class="dash-filter-label">Period</span>
            <Multiselect
              v-model="filter_time"
              :options="times"
              :canClear="false"
            />
          </div>
          <button
            type="button"
            class="dash-icon-btn"
            :title="$t('dashCustomize')"
            @click="showDashboardComponet('card')"
          >
            <i class="material-icons-round">settings</i>
          </button>
        </div>
      </div>
      <!-- <material-button
        class="btn-background btn-sm d-flex align-items-center switch-type"
        style="text-transform: none"
      >
        <i class="material-icons-round opacity-10 fs-5 me-2"
          >account_circle</i
        >
        Membership
      </material-button> -->
      <div class="row g-3 mt-1" v-if="dataDashBoard">
        <div
          v-for="card in kpiCards"
          :key="card.key"
          class="col-xl-3 col-6"
        >
          <div class="kpi-card">
            <div class="kpi-head">
              <div class="kpi-title">{{ card.title }}</div>
              <div v-if="card.hint" class="kpi-hint">{{ card.hint }}</div>
            </div>
            <div class="kpi-value">{{ card.value ?? "-" }}</div>
            <div
              class="kpi-diff"
              :class="'kpi-diff-' + card.difference.status"
            >
              <template v-if="card.difference.status !== 0">
                <i class="material-icons-round">
                  {{ card.difference.status == 1 ? "north" : "south" }}
                </i>
                <span>{{ growthRationText(card.difference.ratio, card.difference.status) }}</span>
              </template>
              <template v-else>
                <i class="material-icons-round">trending_flat</i>
                <span>{{ noGrowthText(card.difference.ratio) }}</span>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="row g-2 mt-2" v-if="dataDashBoard && statCards.length">
        <div
          v-for="stat in statCards"
          :key="stat.key"
          class="col-xl-3 col-lg-4 col-6"
        >
          <div class="stat-card">
            <div class="stat-title">{{ stat.title }}</div>
            <div class="stat-value">{{ stat.value ?? "-" }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="container mb-4 dash-card" v-if="isLoadData">
      <div class="card-body p-0">
        <div class="dash-header">
          <div class="dash-title title-page mb-0">
            <i class="material-icons-round dash-title-icon">bolt</i>
            <span>{{ $t("dashQuickAccess") }}</span>
          </div>
          <button
            type="button"
            class="dash-icon-btn"
            :title="$t('dashCustomize')"
            @click="showDashboardComponet('shortcut')"
          >
            <i class="material-icons-round">settings</i>
          </button>
        </div>
        <div class="row g-2 quick-access">
          <div
            class="col-xl-2 col-lg-3 col-md-4 col-6"
            v-if="
              !config_dashboard_shortcut || config_dashboard_shortcut.viewMember
            "
          >
            <div class="quick-access-box" @click="quickAccess(2)">
              <i class="material-icons-round opacity-10 fs-5 me-2">
                person_search
              </i>
              <div>View A Member</div>
            </div>
          </div>
          <div
            class="col-xl-2 col-lg-3 col-md-4 col-6"
            v-if="
              !config_dashboard_shortcut || config_dashboard_shortcut.menuSet
            "
          >
            <div class="quick-access-box" @click="quickAccess(3)">
              <i class="material-icons-round opacity-10 fs-5 me-2"> menu </i>
              <div>Menu Set</div>
            </div>
          </div>
          <div
            class="col-xl-2 col-lg-3 col-md-4 col-6"
            v-if="
              !config_dashboard_shortcut ||
              config_dashboard_shortcut.orderStatus
            "
          >
            <div class="quick-access-box" @click="quickAccess(4)">
              <i class="material-icons-round opacity-10 fs-5 me-2"> toc </i>
              <div>Order Status</div>
            </div>
          </div>
          <div
            class="col-xl-2 col-lg-3 col-md-4 col-6"
            v-if="
              !config_dashboard_shortcut || config_dashboard_shortcut.stockLinks
            "
          >
            <div class="quick-access-box" @click="quickAccess(5)">
              <i class="material-icons-round opacity-10 fs-5 me-2">
                inventory_2
              </i>
              <div>Item On/Off</div>
            </div>
          </div>
          <div
            class="col-xl-2 col-lg-3 col-md-4 col-6"
            v-if="!config_dashboard_shortcut || config_dashboard_shortcut.kds"
          >
            <div class="quick-access-box" @click="quickAccess(15)">
              <i class="material-icons-round opacity-10 fs-5 me-2"> kitchen </i>
              <div>KDS</div>
            </div>
          </div>
          <div
            class="col-xl-2 col-lg-3 col-md-4 col-6"
            v-if="
              !config_dashboard_shortcut ||
              config_dashboard_shortcut.dailyCollection
            "
          >
            <div class="quick-access-box" @click="quickAccess(1)">
              <i class="material-icons-round opacity-10 fs-5 me-2">
                assessment
              </i>
              <div>Daily Collection</div>
            </div>
          </div>
          <div
            class="col-xl-2 col-lg-3 col-md-4 col-6"
            v-if="
              !config_dashboard_shortcut || config_dashboard_shortcut.itemSales
            "
          >
            <div class="quick-access-box" @click="quickAccess(6)">
              <i class="material-icons-round opacity-10 fs-5 me-2">
                assessment
              </i>
              <div>Item Sales Report</div>
            </div>
          </div>
          <div
            class="col-xl-2 col-lg-3 col-md-4 col-6"
            v-if="
              !config_dashboard_shortcut || config_dashboard_shortcut.itemSalesWithModifiers
            "
          >
            <div class="quick-access-box" @click="quickAccess(7)">
              <i class="material-icons-round opacity-10 fs-5 me-2">
                assessment
              </i>
              <div>Item Sales with Modifiers</div>
            </div>
          </div>
          <div
            class="col-xl-2 col-lg-3 col-md-4 col-6"
            v-if="
              !config_dashboard_shortcut || config_dashboard_shortcut.paidOnlineOrders
            "
          >
            <div class="quick-access-box" @click="quickAccess(8)">
              <i class="material-icons-round opacity-10 fs-5 me-2">
                assessment
              </i>
              <div>Paid Online Orders</div>
            </div>
          </div>
          <div
            class="col-xl-2 col-lg-3 col-md-4 col-6"
            v-if="
              !config_dashboard_shortcut || config_dashboard_shortcut.paidKioskOrders
            "
          >
            <div class="quick-access-box" @click="quickAccess(9)">
              <i class="material-icons-round opacity-10 fs-5 me-2">
                assessment
              </i>
              <div>Paid Kiosk Orders</div>
            </div>
          </div>
          <div
            class="col-xl-2 col-lg-3 col-md-4 col-6"
            v-if="
              !config_dashboard_shortcut || config_dashboard_shortcut.posTransactions
            "
          >
            <div class="quick-access-box" @click="quickAccess(10)">
              <i class="material-icons-round opacity-10 fs-5 me-2">
                assessment
              </i>
              <div>POS Transactions</div>
            </div>
          </div>
          <div
            class="col-xl-2 col-lg-3 col-md-4 col-6"
            v-if="
              !config_dashboard_shortcut || config_dashboard_shortcut.posSimulator
            "
          >
            <div class="quick-access-box" @click="quickAccess(11)">
              <i class="material-icons-round opacity-10 fs-5 me-2">
                point_of_sale
              </i>
              <div>POS Simulator</div>
            </div>
          </div>
          <div
            class="col-xl-2 col-lg-3 col-md-4 col-6"
            v-if="
              !config_dashboard_shortcut || config_dashboard_shortcut.stockInOut
            "
          >
            <div class="quick-access-box" @click="quickAccess(12)">
              <i class="material-icons-round opacity-10 fs-5 me-2">
                inventory_2
              </i>
              <div>Stock In/Out</div>
            </div>
          </div>
          <div
            class="col-xl-2 col-lg-3 col-md-4 col-6"
            v-if="
              !config_dashboard_shortcut || config_dashboard_shortcut.stockTransfers
            "
          >
            <div class="quick-access-box" @click="quickAccess(13)">
              <i class="material-icons-round opacity-10 fs-5 me-2">
                compare_arrows
              </i>
              <div>Stock Transfers</div>
            </div>
          </div>
          <div
            class="col-xl-2 col-lg-3 col-md-4 col-6"
            v-if="
              !config_dashboard_shortcut || config_dashboard_shortcut.salesChannel
            "
          >
            <div class="quick-access-box" @click="quickAccess(14)">
              <i class="material-icons-round opacity-10 fs-5 me-2">
                storefront
              </i>
              <div>Sales Channel</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container mb-4 dash-card" v-if="isLoadData">
      <EodSummary
        :physical-branch-id="Number(physicalBranchSelected) || 0"
        :time-type="Number(filter_time) || 1"
        :config="config_dashboard_eod"
        @customize="showDashboardComponet('eod')"
      />
    </div>
    <div class="container mb-4 dash-card" v-if="isLoadData && insightMetrics.length">
      <div class="card-body p-0">
        <div class="d-flex justify-content-between align-items-center insights-section-header">
          <div class="d-flex align-items-center">
            <span class="material-icons-round insights-section-icon">auto_awesome</span>
            <div>
              <div class="title-page mb-0">{{ $t('insightsSectionTitle') }}</div>
              <div class="insights-section-subtitle">{{ $t('insightsSectionSubtitle') }}</div>
            </div>
          </div>
          <button
            type="button"
            class="insights-refresh-btn"
            @click="refreshInsights"
            :title="$t('insightsRefresh')"
          >
            <i class="material-icons-round">refresh</i>
          </button>
        </div>
        <div class="row chart-list mt-3 g-3">
          <div
            class="col-lg-6 col-12"
            v-for="metric in insightMetrics"
            :key="metric"
          >
            <InsightCard :metric="metric" :refresh-nonce="insightsRefreshNonce" />
          </div>
        </div>
      </div>
    </div>
    <div class="container mb-4 dash-card" v-if="isLoadData && dataDashBoard">
      <div class="card-body p-0">
        <div class="dash-header">
          <div class="dash-title title-page mb-0">
            <i class="material-icons-round dash-title-icon">leaderboard</i>
            <span>{{ $t("dashReports") }}</span>
          </div>
          <button
            type="button"
            class="dash-icon-btn"
            :title="$t('dashCustomize')"
            @click="showDashboardComponet('chart')"
          >
            <i class="material-icons-round">settings</i>
          </button>
        </div>
        <div class="row g-3 chart-list">
          <div class="col-lg-6 col-12" v-if="config_dashboard_chart && config_dashboard_chart.spendingLeaderboard">
            <div class="chart-box">
              <div class="c-title">Spending Leaderboard</div>
              <div class="table-responsive p-0 mt-2">
                <table class="table align-items-center mb-0 dash-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Member Name</th>
                      <th>Phone No</th>
                      <th class="text-end">Amount Spend</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!dataDashBoard.top_members_spend || !dataDashBoard.top_members_spend.length">
                      <td colspan="4" class="dash-empty">{{ $t("dashNoData") }}</td>
                    </tr>
                    <tr
                      v-for="(item, index) in dataDashBoard.top_members_spend"
                      :key="index"
                    >
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.phone_number }}</td>
                      <td class="text-end">$ {{ money(item.total_spend) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12" v-if="!config_dashboard_chart || (config_dashboard_chart && config_dashboard_chart.recentTransactions)">
            <div class="chart-box">
              <div class="c-title">Recent Transactions</div>
              <div class="table-responsive p-0 mt-2">
                <table class="table align-items-center mb-0 dash-table">
                  <thead>
                    <tr>
                      <th>Receipt No</th>
                      <th>Transaction Id</th>
                      <th>Order Date Time</th>
                      <th class="text-end">Total Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!dataDashBoard.recent_transactions || !dataDashBoard.recent_transactions.length">
                      <td colspan="4" class="dash-empty">{{ $t("dashNoData") }}</td>
                    </tr>
                    <tr
                      v-for="(item, index) in dataDashBoard.recent_transactions"
                      :key="index"
                    >
                      <td>{{ item.receipt_no }}</td>
                      <td @click="showTransactionDetail(item.transaction_id)" class="cursor-pointer dash-link">{{ item.transaction_id }}</td>
                      <td>{{ item.created_at_format }}</td>
                      <td class="text-end">$ {{ money(item.total_amount) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12" v-if="!config_dashboard_chart || (config_dashboard_chart && config_dashboard_chart.branchesRevenueLeaderboard)">
            <div class="chart-box">
              <div class="c-title">Branches Revenue Leaderboard</div>
              <bar-chart-vertical
                v-if="showTotalRevenueBranchesChart"
                :series="dataDashBoard.total_revenue_branches.yData"
                :labels="dataDashBoard.total_revenue_branches.xData"
                :crossFilter="true"
              ></bar-chart-vertical>
            </div>
          </div>
          <div class="col-lg-6 col-12" v-if="config_dashboard_chart && config_dashboard_chart.itemsRevenueLeaderboardByType">
            <div class="chart-box">
              <div class="c-title">Items Revenue Leaderboard By Type</div>
              <bar-chart-horizontal
                v-if="showHighestRevenueItemsChartByType"
                :series="dataDashBoard.highest_revenue_items_by_type.xData"
                :labels="dataDashBoard.highest_revenue_items_by_type.yData"
                :crossFilter="true"
              ></bar-chart-horizontal>
            </div>
          </div>
          <div class="col-lg-6 col-12" v-if="config_dashboard_chart && config_dashboard_chart.itemsRevenueLeaderboard">
            <div class="chart-box">
              <div class="c-title">Items Revenue Leaderboard</div>
              <bar-chart-horizontal
                v-if="showHighestRevenueItemsChart"
                :series="dataDashBoard.highest_revenue_items.xData"
                :labels="dataDashBoard.highest_revenue_items.yData"
              ></bar-chart-horizontal>
            </div>
          </div>
          <div class="col-lg-6 col-12" v-if="!config_dashboard_chart || config_dashboard_chart.categorySales !== false">
            <div class="chart-box">
              <div class="d-flex justify-content-between align-items-center c-title">
                <div>Category Sales Report</div>
                <select
                  class="form-select category-export-select"
                  v-model="categorySalesExport"
                  @change="exportCategorySales"
                >
                  <option value="0">Export</option>
                  <option value="xlsx">Excel (.xlsx)</option>
                  <option value="csv">CSV (.csv)</option>
                </select>
              </div>
              <div class="table-responsive p-0 mt-2">
                <table class="table align-items-center mb-0 dash-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Category</th>
                      <th class="text-end">Qty Sold</th>
                      <th class="text-end">Total Sales</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!dataDashBoard.category_sales || !dataDashBoard.category_sales.length">
                      <td colspan="4" class="dash-empty">{{ $t("dashNoData") }}</td>
                    </tr>
                    <tr
                      v-for="(item, index) in dataDashBoard.category_sales"
                      :key="index"
                    >
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.category_name }}</td>
                      <td class="text-end">{{ item.quantity }}</td>
                      <td class="text-end">$ {{ money(item.total) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <form
                :action="`${actionDownload}/merchant/download-category-sales-report`"
                method="POST"
              >
                <input type="hidden" name="merchantId" :value="merchantIdExport" />
                <input type="hidden" name="merchant_code" :value="merchantCode" />
                <input type="hidden" name="token" :value="token" />
                <input type="hidden" name="physical_branch_id" :value="physicalBranchSelected" />
                <input type="hidden" name="time_type" :value="filter_time" />
                <input type="hidden" name="action" value="export" />
                <input type="hidden" name="action_export" :value="categorySalesExport" />
                <input type="hidden" name="checkExport" :value="checkExportCategory" />
                <input id="downloadCategorySalesForm" type="submit" class="d-none" />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalDashboardComponet
      @reload-data="reloadData()"
      :configType="configType"
      :key-reload="keyReloadModalDashboardComponet"
    ></ModalDashboardComponet>
    <ModalSearchMember
      :key-reload="keyReloadModalSearchMember"
    ></ModalSearchMember>
    <ModalListLinks
      :key-reload="keyReloadModalListLinks"
      :linkType="linkType"
    ></ModalListLinks>
    <ModalTransactionDetail
      :transactionDetail="transactionDetail"
    ></ModalTransactionDetail>
  </div>
  <material-loading :active="loaderActive" />
  <div class="position-fixed top-1 end-1 z-index-2 message-success">
    <material-snackbar
      v-if="snackbar === 'danger' || snackbar === 'success'"
      title
      date
      :description="message"
      :icon="{ component: 'campaign', color: 'white' }"
      :color="snackbar"
      :close-handler="closeSnackbar"
    />
  </div>
</template>

<script>
import router from "@/router";
import TokenService from "../../services/token.service";
import Multiselect from "@vueform/multiselect";
import DashboardService from "../../services/dashboard.service";
import AnextService from "../../services/anext.service";
import InsightsService from "../../services/insights.service";
import InsightCard from "@/components/InsightCard.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import BarChartHorizontal from "../components/chart/BarChartHorizontal.vue";
import BarChartVertical from "../components/chart/BarChartVertical.vue";
// import GroupBarChart from "../views/components/chart/GroupBarChart.vue";
// import GroupLineChart from "../views/components/chart/GroupLineChart.vue";
// import PieChart from "../views/components/chart/PieChart.vue";
// import LineChart from "../views/components/chart/LineChart.vue";
import ModalDashboardComponet from "@/components/ModalDashboardComponet.vue";
import $ from "jquery";
import SmsSetupService from "../../services/smsSetup.service";
import EventBus from "vue3-eventbus";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import ModalSearchMember from "./components/ModalSearchMember.vue";
import ModalListLinks from "./components/ModalListLinks.vue";
import ModalTransactionDetail from "./components/ModalTransactionDetail.vue";
import EodSummary from "./components/EodSummary.vue";

export default {
  name: "home",
  inject: ['updateMainContentMargin', 'forceUpdateMargin'],
  components: {
    Multiselect,
    MaterialLoading,
    BarChartHorizontal,
    BarChartVertical,
    // GroupBarChart,
    // GroupLineChart,
    // PieChart,
    // LineChart,
    ModalDashboardComponet,
    MaterialSnackbar,
    ModalSearchMember,
    ModalListLinks,
    ModalTransactionDetail,
    InsightCard,
    EodSummary,
  },
  data() {
    return {
      snackbar: null,
      message: "",
      merchant_name: "",
      isLoadData: false,
      loaderActive: false,
      filter_time: 1,
      times: [
        { value: 1, label: "Today" },
        { value: 5, label: "This month" },
        { value: 7, label: "This year" },
      ],
      dataDashBoard: null,
      smsBal: 0,
      isShowWarningSms: 1, // never show,
      showHighestRevenueItemsChart: false,
      showHighestRevenueItemsChartByType: false,
      showTotalRevenueBranchesChart: false,
      physicalBranches: [],
      physicalBranchSelected: 0,
      keyReloadModalSearchMember: "keyReloadModalSearchMember",
      keyReloadModalListLinks: "keyReloadModalListLinks",
      keyReloadModalDashboardComponet: "keyReloadModalDashboardComponet",
      linkType: 1,
      configType: "card",
      config_dashboard_card: null,
      config_dashboard_shortcut: null,
      config_dashboard_chart: null,
      config_dashboard_eod: null,
      transactionDetail: null,
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      token: TokenService.getLocalAccessToken(),
      categorySalesExport: 0,
      checkExportCategory: false,
      insightMetrics: [],
      insightsRefreshNonce: 0,
    };
  },
  async created() {
    this.isLoadData = false;
    this.showLoader();
    await this.getData();
    await this.getSmsBal();
    this.hideLoader();
    this.isLoadData = true;
    this.loadInsightsCatalog();

    // Cập nhật margin sau khi data load xong
    this.$nextTick(() => {
      if (this.updateMainContentMargin) {
        this.updateMainContentMargin();
      }
    });
  },
  mounted() {
    const code = localStorage.getItem("MERCHANT_CODE", "");
    const token = TokenService.getLocalAccessToken();
    this.merchant_name = localStorage
      .getItem("MERCHANT_NAME", "")
      .toUpperCase();
    if (!token || !code) {
      router.push("sign-in");
    }

    EventBus.on("ReloadHighestRevenueItemsChart", (index) => {
      if (
        this.dataDashBoard.highest_revenue_items_by_type &&
        this.dataDashBoard.highest_revenue_items_by_type.type_ids.length
      ) {
        let typeId = this.dataDashBoard.highest_revenue_items_by_type.type_ids[
          index
        ];
        this.reloadChart(typeId);
      }
    });

    EventBus.on("ReloadItemRevenueByTypeChart", (index) => {
      if (
        this.dataDashBoard.total_revenue_branches &&
        this.dataDashBoard.total_revenue_branches.branch_ids.length
      ) {
        let branchId = this.dataDashBoard.total_revenue_branches.branch_ids[
          index
        ];
        this.reloadChart(branchId, 2);
      }
    });
  },
  computed: {
    // The 4 headline cards, shown unless the merchant switched them off.
    kpiCards() {
      const data = this.dataDashBoard;
      const config = this.config_dashboard_card;
      const cards = [
        { key: "totalSales", title: "Total Sales", item: data.total_sales },
        {
          key: "netSales",
          title: "Net Sales",
          hint: "Before Service Charge and GST, if any",
          item: data.total_net_sales,
        },
        { key: "transactions", title: "Transactions", item: data.bill_count },
        { key: "memberTransactions", title: "Member Transactions", item: data.member_bill_count },
      ];

      return cards
        .filter((card) => !config || config[card.key])
        .map((card) => ({
          key: card.key,
          title: card.title,
          hint: card.hint,
          value: card.item.current,
          difference: card.item.difference,
        }));
    },
    // The smaller figures, shown only when the merchant switched them on.
    statCards() {
      const data = this.dataDashBoard;
      const config = this.config_dashboard_card;

      if (!config) {
        return [];
      }

      return [
        { key: "serviceCharge", title: "Service Charge", value: data.total_service_charge.current },
        { key: "gst", title: "GST", value: data.total_gst.current },
        { key: "billDiscount", title: "Bill Discount", value: data.total_discount.current },
        { key: "avgBillSize", title: "Avg Bill Size", value: data.avg_bill.current },
        { key: "voidAmount", title: "Void Amount", value: data.total_void_amount.current },
        { key: "totalMembers", title: "Total Members", value: data.total_members.all },
        { key: "totalPax", title: "Total Pax", value: data.total_pax.current },
        { key: "spendingPerPax", title: "Spending Per Pax", value: data.spending_per_pax.current },
      ].filter((stat) => config[stat.key]);
    },
  },
  methods: {
    loadInsightsCatalog() {
      const METRIC_ORDER = ['winback', 'quiet-days', 'menu-engineering', 'forecast', 'outlet-compare'];
      InsightsService.getCatalog()
        .then((res) => {
          const body = res.data;
          if (!body.result.isSuccess) {
            this.insightMetrics = [];
            return;
          }
          const metrics = (body.data && body.data.metrics) || [];
          const available = new Set(metrics.filter((m) => m.entitled).map((m) => m.metric));
          this.insightMetrics = METRIC_ORDER.filter((metric) => available.has(metric));
        })
        .catch(() => {
          this.insightMetrics = [];
        });
    },
    refreshInsights() {
      this.insightsRefreshNonce += 1;
    },
    openAnextBanner() {
      if (!this.dataDashBoard || !this.dataDashBoard.anext_eligible) {
        this.snackbar = "danger";
        this.message = "Your business is not eligible for ANEXT CreditNow at the moment.";
        this.setTimeOutNotification();
        return;
      }
      if (this.dataDashBoard.anext_banner_url) {
        window.open(this.dataDashBoard.anext_banner_url, "_blank");
      }
      AnextService.bind().catch(() => {});
    },
    quickAccess(index) {
      if (index == 1) {
        this.$router.push({
          name: "PosDailyCollectionsReport",
        });
      } else if (index == 2) {
        this.keyReloadModalSearchMember = Math.random();
        $(".btn-show-search-member-modal").click();
      } else if (index == 3) {
        this.$router.push({
          name: "MenuSet",
        });
      } else if (index == 4) {
        this.linkType = 2;
        this.keyReloadModalListLinks = Math.random();
        $(".btn-show-list-links-modal").click();
      } else if (index == 5) {
        this.linkType = 1;
        this.keyReloadModalListLinks = Math.random();
        $(".btn-show-list-links-modal").click();
      } else if (index == 6) {
        this.$router.push({
          name: "ItemSalesReport",
        });
      } else if (index == 7) {
        this.$router.push({
          name: "ItemSalesWithModifiersReport",
        });
      } else if (index == 8) {
        this.$router.push({
          name: "DashboardReportOnlineOrdering",
        });
      } else if (index == 9) {
        this.$router.push({
          name: "DashboardReportKiosk",
        });
      } else if (index == 10) {
        this.$router.push({
          name: "DashboardReportPosTransaction",
        });
      } else if (index == 11) {
        this.$router.push({
          name: "Test",
        });
      } else if (index == 12) {
        this.$router.push({
          name: "StockInOut",
        });
      } else if (index == 13) {
        this.$router.push({
          name: "StockTransfers",
        });
      } else if (index == 14) {
        this.$router.push({
          name: "StoreList",
        });
      } else if (index == 15) {
        this.linkType = 3;
        this.keyReloadModalListLinks = Math.random();
        $(".btn-show-list-links-modal").click();
      }
    },

    growthRationText(ratio, status) {
      return (status == 1 ? "+" : "-") + ratio + " from " + this.previousPeriodText();
    },

    previousPeriodText() {
      if (this.filter_time == 5) {
        return "last month";
      }

      return this.filter_time == 7 ? "last year" : "yesterday";
    },

    // status 0: 'NA' when the previous period had nothing to compare with, '0%' when equal.
    noGrowthText(ratio) {
      return ratio === "NA"
        ? this.$t("dashNoBaseline", { period: this.previousPeriodText() })
        : this.$t("dashNoChange", { period: this.previousPeriodText() });
    },

    money(value) {
      return new Intl.NumberFormat("en", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(parseFloat(value ?? 0));
    },

    showDashboardComponet(type) {
      this.configType = type;
      this.keyReloadModalDashboardComponet = Math.random();
      $("#btn-show-dashboard-component").click();
    },
    async reloadData(config) {
      this.showLoader();
      await this.getData(config);
      this.hideLoader();
    },
    async getData(config = null) {
      this.showHighestRevenueItemsChart = false;
      this.showHighestRevenueItemsChartByType = false;
      this.showTotalRevenueBranchesChart = false;

      if (config) {
        if (this.configType == "card") {
          this.config_dashboard_card = config;
        } else if (this.configType == "shortcut") {
          this.config_dashboard_shortcut = config;
        } else if (this.configType == "chart") {
          this.config_dashboard_chart = config;
        } else if (this.configType == "eod") {
          this.config_dashboard_eod = config;
        }
      }

      await DashboardService.getData({
        physical_branch_id: this.physicalBranchSelected,
        time_type: this.filter_time,
      }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.showHighestRevenueItemsChart = true;
            this.showHighestRevenueItemsChartByType = true;
            this.showTotalRevenueBranchesChart = true;
            this.dataDashBoard = response.data.data;
            this.checkExportCategory = true;
            this.physicalBranches = this.dataDashBoard.physical_branches;
            this.config_dashboard_card =
              response.data.data.config_dashboard_card;
            this.config_dashboard_shortcut =
              response.data.data.config_dashboard_shortcut;
            this.config_dashboard_chart =
              response.data.data.config_dashboard_chart;
            this.config_dashboard_eod =
              response.data.data.config_dashboard_eod;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
        }
      );
    },
    exportCategorySales() {
      if (
        this.categorySalesExport == "xlsx" ||
        this.categorySalesExport == "csv"
      ) {
        setTimeout(() => {
          $("#downloadCategorySalesForm").click();
        }, 150);
        setTimeout(() => {
          this.categorySalesExport = 0;
        }, 500);
      }
    },
    async reloadChart(id, type = 1) {
      this.showLoader();
      let formData = {
        time_type: this.filter_time,
        physical_branch_id: this.physicalBranchSelected,
      };

      if (type === 1) {
        this.showHighestRevenueItemsChart = false;
        formData.type_id = id;
      } else {
        this.showHighestRevenueItemsChart = false;
        this.showHighestRevenueItemsChartByType = false;
        formData.branch_id = id;
      }

      await DashboardService.reloadChart(formData).then(
        (response) => {
          if (response.data.result.isSuccess) {
            if (type === 1) {
              this.showHighestRevenueItemsChart = true;
              this.showHighestRevenueItemsChartByType = true;
            } else {
              this.showHighestRevenueItemsChart = true;
              this.showHighestRevenueItemsChartByType = true;
              this.dataDashBoard.highest_revenue_items_by_type =
                response.data.data.highest_revenue_items_by_type;
            }

            this.dataDashBoard.highest_revenue_items =
              response.data.data.highest_revenue_items;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },
    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
    async getSmsBal() {
      await SmsSetupService.getSmsBal().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.smsBal = response.data.data.smsBal;
            this.isShowWarningSms = response.data.data.isShowWarningSms;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
        }
      );
    },
    closeWarningSms() {
      this.isLoadData = false;
      this.showLoader();
      SmsSetupService.closeWarningSms().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.isShowWarningSms = 3;
            this.isLoadData = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },
    showTransactionDetail(transactionId) {
      this.showLoader();
      this.transactionDetail = null;
      DashboardService.detailTransaction({
        transaction_id: transactionId,
      }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.transactionDetail = response.data.data;
            $(".btn-show-transaction-detail-modal").click();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error.response.data.result.message;
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },
    gotoStokPage(link) {
      window.open(link, "_blank");
    },
  },
  watch: {
    async filter_time(val) {
      this.showLoader();
      if (val) {
        await this.getData();
      }
      this.hideLoader();
    },
    async physicalBranchSelected() {
      this.showLoader();
      await this.getData();
      this.hideLoader();
    },
  },
};
</script>

<style scoped>
.page-header {
  min-height: calc(100vh - 65px) !important;
}

.category-export-select {
  width: auto;
  min-width: 120px;
  cursor: pointer;
  font-size: 0.8rem;
  padding: 0.25rem 1.75rem 0.25rem 0.75rem;
}

.anext-banner {
  border-radius: 10px;
  cursor: pointer;
  overflow: hidden;
}

.anext-banner img {
  display: block;
  width: 100%;
}

/* SMS credit warning */
.sms-warning {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: #ef5350;
  color: #fff;
  padding: 10px 16px;
}

.sms-warning-text {
  display: flex;
  align-items: center;
}

.sms-warning a {
  color: #fff;
  text-decoration: underline;
}

.sms-warning-close {
  border: none;
  background: transparent;
  color: #fff;
  display: flex;
  cursor: pointer;
}

/* Sections */
.dash-card {
  background: #fff;
  border-radius: 15px;
  padding: 20px 24px;
}

.dash-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.dash-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dash-title-icon {
  display: flex;
  align-items: center;
  color: #133067;
  font-size: 22px !important;
}

.dash-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.dash-filter {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 220px;
}

.dash-filter-label {
  min-width: 48px;
  font-weight: bold;
}

.dash-filter :deep(.multiselect) {
  min-width: 170px;
}

.dash-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  color: #7b809a;
  cursor: pointer;
}

.dash-icon-btn:hover {
  color: #000;
}

.dash-icon-btn .material-icons-round {
  font-size: 20px;
}

/* Headline cards */
.kpi-card {
  height: 100%;
  border-radius: 15px;
  padding: 10px 20px 14px;
  background: #e6e6e6;
}

.kpi-head {
  min-height: 50px;
}

.kpi-title {
  color: #595959;
  font-size: 20px;
  font-weight: bold;
}

.kpi-hint {
  color: #595959;
  font-size: 11px;
}

.kpi-value {
  color: #000;
  font-size: 28px;
  font-weight: bold;
}

.kpi-diff {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 16px;
  font-size: 14px;
}

.kpi-diff .material-icons-round {
  font-size: 18px;
}

.kpi-diff-1 {
  color: #2e9e3e;
}

.kpi-diff-0 {
  color: #595959;
}

.kpi-diff--1 {
  color: #eb2f06;
}

/* Smaller figures */
.stat-card {
  padding: 10px 16px;
  height: 100%;
}

.stat-title {
  color: #595959;
  font-size: 16px;
  font-weight: bold;
}

.stat-value {
  color: #000;
  font-size: 20px;
  font-weight: bold;
  margin-top: 4px;
}

/* Quick access */
.quick-access-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 100%;
  min-height: 80px;
  padding: 12px 8px;
  border-radius: 10px;
  background: #e6e6e6;
  color: #595959;
  font-size: 13px;
  text-align: center;
  cursor: pointer;
  transition: background 0.15s ease;
}

.quick-access-box:hover {
  background: #d9d9d9;
}

.quick-access-box i {
  margin: 0 !important;
  color: #000;
  font-size: 26px !important;
}

/* Leaderboards & reports */
.chart-box {
  background: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 15px;
  padding: 20px 20px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  text-align: center;
  height: 100%;
}

.chart-box .c-title {
  font-size: 20px !important;
  color: #133067;
  margin-bottom: 20px;
  border-bottom: 1px solid #133067;
  font-weight: 500 !important;
  text-align: left;
}

.dash-table {
  text-align: left;
}



.dash-table td {
  font-variant-numeric: tabular-nums;
}

.dash-link {
  color: #133067;
  text-decoration: underline;
}

.dash-empty {
  text-align: center !important;
  padding: 24px 0 !important;
}

/* Business insights */
.insights-section-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: linear-gradient(135deg, #133067, #2f5aa8);
  color: #fff;
  font-size: 20px !important;
  margin-right: 12px;
  flex: 0 0 auto;
}

.insights-section-subtitle {
  color: #525c70;
  font-size: 12.5px;
  margin-top: 2px;
}

.insights-refresh-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: #f5f6fa;
  color: #133067;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease;
}

.insights-refresh-btn:hover {
  background: #eef1fb;
  transform: rotate(45deg);
}

.insights-refresh-btn .material-icons-round {
  font-size: 18px;
}

.material-icons {
  width: 20px !important;
}

@media screen and (max-width: 768px) {
  .dash-card {
    padding: 16px;
  }

  .dash-filters,
  .dash-filter {
    width: 100%;
  }

  .dash-filter :deep(.multiselect) {
    flex: 1;
  }

  .kpi-card {
    padding: 12px 14px;
  }

  .kpi-value {
    font-size: 22px;
  }

  .kpi-title {
    font-size: 16px;
  }

  .search-box,
  .language-selector {
    margin-top: 15px;
  }
}
</style>
